module.exports = {
  "id": "flower",
  "title": "flower",
  "image": "provision/parts/flower/flower.png",
  "info": [
    {
      "text": "Add a flower to your project",
      "image": "provision/parts/flower/flower.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/flower/flower.png"
} ;